import React from 'react';

const ConfirmationModal = ({ onConfirm, onCancel }) => {
  return (
    <div className="confirmation-modal-overlay-confirmationmodal">
      <div className="confirmation-modal-confirmationmodal">
        <p className="confirmation-text-confirmationmodal">
          You'll lose the current dialogue progress if you exit. Are you sure?
        </p>
        <div className="confirmation-buttons-confirmationmodal">
          <button className="confirm-button-confirmationmodal" onClick={onConfirm}>
            Yes
          </button>
          <button className="cancel-button-confirmationmodal" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
